export const parseAnyFloat = (value: any): number => (value ? parseFloat(String(value)) : 0);
